import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  HOME_MAIN_SLIDER_PAGE_PATH,
  HOME_MAIN_SLIDER_PAGE_ADD_PATH,
  HOME_MAIN_SLIDER_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const HomePageSlider = Loadable(React.lazy(() => import("./View")));
const HomePageSliderAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const HomePageSliderRoute: IRouteItem = {
  path: HOME_MAIN_SLIDER_PAGE_PATH,
  element: React.createElement(HomePageSlider),
  name: "Home Slider Listing",
  children: [
    {
      name: "Add / Update",
      path: HOME_MAIN_SLIDER_PAGE_ADD_PATH,
      element: React.createElement(HomePageSliderAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: HOME_MAIN_SLIDER_PAGE_UPDATE_PATH,
      element: React.createElement(HomePageSliderAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
